import { Collapse } from '@mui/material';
import { FC } from 'react';
import { useSnapshot } from 'valtio';
import SnoozeExpiredBanner from '../components/SnoozeExpiredBanner';
import {
  setBannerSnoozeDay,
  setBannerSnoozeWeek,
} from '../store-actions/exclusions-store-actions';
import ExclusionsStore from '../stores/exclusions-store';

const SnoozeBannerContainer: FC = () => {
  const { bannerSnoozeWeek, bannerSnoozeDay, exclusionsExpiredWeek } =
    useSnapshot(ExclusionsStore);

  const handleCloseWeekBanner = () => {
    setBannerSnoozeWeek(false);
  };

  const handleCloseDaykBanner = () => {
    setBannerSnoozeDay(false);
  };

  return (
    <Collapse in={bannerSnoozeWeek || bannerSnoozeDay}>
      <SnoozeExpiredBanner
        week={bannerSnoozeWeek}
        day={bannerSnoozeDay}
        exclusionsExpiredWeek={exclusionsExpiredWeek}
        onClose={
          bannerSnoozeWeek ? handleCloseWeekBanner : handleCloseDaykBanner
        }
      />
    </Collapse>
  );
};

export default SnoozeBannerContainer;
